import { render, staticRenderFns } from "./section-period-chart.vue?vue&type=template&id=fafe4996&scoped=true"
import script from "./section-period-chart.vue?vue&type=script&lang=js"
export * from "./section-period-chart.vue?vue&type=script&lang=js"
import style0 from "./section-period-chart.vue?vue&type=style&index=0&id=fafe4996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafe4996",
  null
  
)

export default component.exports